export default __webpack_public_path__ + "static/media/550.2e1f68cf.jpg";